/* ============================================================
   DOTE THEME — Global JavaScript
   File: assets/dote-theme.js
   Load with defer — after GSAP, ScrollTrigger, and Lenis CDN tags.
   ============================================================ */

(function () {
  'use strict';

  /* ── Lenis smooth scroll ──────────────────────────────────── */
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    wheelMultiplier: 1,
  });
  window.lenis = lenis;
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => { lenis.raf(time * 1000); });
  gsap.ticker.lagSmoothing(0);
  gsap.registerPlugin(ScrollTrigger);

  /* ── Product Explorer filter ──────────────────────────────── */
  const explorerFilterBtns = document.querySelectorAll('[data-explorer-filter]');
  const explorerCards = document.querySelectorAll('[data-product-card]');
  const goFilterLinks = document.querySelectorAll('[data-go-filter]');

  function setExplorerFilter(filter) {
    explorerFilterBtns.forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.explorerFilter === filter);
    });
    explorerCards.forEach((card) => {
      const cats = (card.dataset.category || '').split(/\s+/);
      card.hidden = !(filter === 'all' || cats.includes(filter));
    });
  }

  explorerFilterBtns.forEach((btn) => {
    btn.addEventListener('click', () => setExplorerFilter(btn.dataset.explorerFilter));
  });
  goFilterLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const f = link.dataset.goFilter;
      if (f) setExplorerFilter(f);
    });
  });
  setExplorerFilter('new');

  /* ── Preloader ────────────────────────────────────────────── */
  let progress = 0;
  const progressEl = document.getElementById('preloaderProgress');
  const preloaderInterval = setInterval(() => {
    progress += Math.floor(Math.random() * 8) + 6;
    if (progress >= 100) {
      progress = 100;
      clearInterval(preloaderInterval);
      if (progressEl) progressEl.style.setProperty('--progress', '100%');
      gsap.to('.preloader', {
        yPercent: -100,
        duration: 1.1,
        ease: 'power4.inOut',
        delay: 0.6,
        onComplete: () => {
          const pre = document.getElementById('preloader');
          if (pre) pre.style.display = 'none';
          initHeroAnimations();
        },
      });
    } else if (progressEl) {
      progressEl.style.setProperty('--progress', progress + '%');
    }
  }, 90);

  /* ── Hero entrance animations ─────────────────────────────── */
  function initHeroAnimations() {
    gsap.timeline()
      .to('.hero-img', { scale: 1, duration: 2, ease: 'power3.out' }, 0)
      .to('.hero-bottom-center', { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }, 0.6);
  }

  /* ── Nav scroll behaviour ─────────────────────────────────── */
  ScrollTrigger.create({
    start: 'top -50',
    end: 99999,
    onEnter: () => {
      document.querySelector('.site-nav')?.classList.add('is-scrolled');
      document.querySelector('.announcement')?.classList.add('is-hidden');
    },
    onLeaveBack: () => {
      document.querySelector('.site-nav')?.classList.remove('is-scrolled');
      document.querySelector('.announcement')?.classList.remove('is-hidden');
    },
  });

  ScrollTrigger.create({
    trigger: '.hero',
    start: 'bottom top',
    end: 99999,
    toggleClass: { className: 'has-glass', targets: '.site-nav' },
  });

  /* ── Bento grid reveal ────────────────────────────────────── */
  gsap.utils.toArray('.bento-item').forEach((item) => {
    gsap.from(item, {
      y: 60, opacity: 0, duration: 1, ease: 'power3.out',
      scrollTrigger: { trigger: item, start: 'top 88%' },
    });
  });

  /* ── Desktop-only: polaroid parallax + horizontal scroll ──── */
  const mm = gsap.matchMedia();
  mm.add('(min-width: 901px) and (prefers-reduced-motion: no-preference)', () => {
    const wowTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.wow-parallax',
        start: 'top top',
        end: 'bottom bottom',
        scrub: 1,
      },
    });
    wowTl.to('.p-left',  { top: '-20vh', rotation: -12, ease: 'none' }, 0);
    wowTl.to('.p-right', { top: '10vh',  rotation:  10, ease: 'none' }, 0.2);

    gsap.utils.toArray('.bento-item').forEach((item) => {
      const img = item.querySelector('img');
      if (!img) return;
      gsap.to(img, {
        yPercent: 8, ease: 'none',
        scrollTrigger: { trigger: item, start: 'top bottom', end: 'bottom top', scrub: true },
      });
    });

    const track = document.querySelector('.horizontal-track');
    if (track) {
      gsap.to(track, {
        x: () => -(track.scrollWidth - window.innerWidth + window.innerWidth * 0.1),
        ease: 'none',
        scrollTrigger: {
          trigger: '.atelier',
          start: 'top top',
          end: () => '+=' + (track.scrollWidth - window.innerWidth),
          scrub: 1,
          pin: '.horizontal-container',
          invalidateOnRefresh: true,
        },
      });
    }
  });

  /* ── Footer giant text reveal ─────────────────────────────── */
  function splitText(sel) {
    document.querySelectorAll(sel).forEach((el) => {
      const text = el.innerText;
      el.innerHTML = '';
      text.split('').forEach((char) => {
        const sp = document.createElement('span');
        sp.className = 'char';
        sp.innerHTML = char === ' ' ? '&nbsp;' : char;
        el.appendChild(sp);
      });
    });
  }
  splitText('.footer-giant');
  gsap.to('.footer-giant .char', {
    y: '0%', duration: 1, stagger: 0.05, ease: 'power3.out',
    scrollTrigger: { trigger: '.main-content', start: 'bottom 80%' },
  });

  /* ── Footer curtain height ────────────────────────────────── */
  function updateFooterCurtain() {
    const footer = document.querySelector('.site-footer');
    const main   = document.querySelector('.main-content');
    if (footer && main) main.style.setProperty('--footer-height', footer.offsetHeight + 'px');
  }
  updateFooterCurtain();
  window.addEventListener('resize', updateFooterCurtain);
  window.addEventListener('load',   updateFooterCurtain);

  /* ── Mobile drawer ────────────────────────────────────────── */
  (function drawerV2() {
    const drawer = document.getElementById('mobileDrawer');
    if (!drawer || drawer.__v2) return;
    drawer.__v2 = true;
    if (drawer.parentElement !== document.documentElement) {
      document.documentElement.appendChild(drawer);
    }
    drawer.removeAttribute('hidden');

    const trigger = document.querySelector('[data-drawer-trigger]');
    let lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.remove('is-closing');
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      document.body.classList.add('drawer-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      try { window.lenis?.stop(); } catch (e) {}
      const first = drawer.querySelector('.mobile-drawer__close, .mobile-drawer__nav a');
      first?.focus({ preventScroll: true });
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      try { window.lenis?.start(); } catch (e) {}
      lastFocus?.focus({ preventScroll: true });
    }

    trigger?.addEventListener('click', open);
    drawer.querySelectorAll('[data-drawer-close]').forEach((el) => el.addEventListener('click', close));
    drawer.querySelectorAll('.mobile-drawer__nav a').forEach((a) => {
      a.addEventListener('click', () => setTimeout(close, 80));
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    drawer.__open  = open;
    drawer.__close = close;
  })();

})();
